module.exports = __webpack_public_path__ + "95fbc481b3ad016658ce703e346c143f.png";